// extracted by mini-css-extract-plugin
export default {"ribbon":"uK61N2_HoDvXzzxjRw0w"};